import clsx from 'clsx';
import React from 'react';

import Icon, { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';

type ErrorDisplay = {
  errorMessage: string;
};

const ErrorDisplay = ({ errorMessage = '' }: ErrorDisplay) => {
  return (
    <span className={clsx('tw-flex tw-items-center', 'tw-text-cfo-red-400 tw-text-[12px]')}>
      <Icon
        icon={ICONS.info}
        iconType={ICON_TYPES.filled}
        className={clsx('tw-text-cfo-red-400 tw-text-[12px]', 'tw-mr-[2px]')}
      />
      {errorMessage}
    </span>
  );
};

export default ErrorDisplay;
